import React from 'react';
import { Box, Typography } from '@mui/material';

const RGP10 = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100vh', 
            bgcolor: '#ffffff'
        }}>
            <Typography variant="h3" gutterBottom>
                RGP10 Under Construction
            </Typography>
            <Typography variant="h6">
                This page is currently under construction. Please check back later.
            </Typography>
        </Box>
    );
};

export default RGP10;